import Vue from 'vue'

const DialogInstance = Vue.extend(require('./index.vue').default);
let instance = null
let dialogPromise = null
let dialogResolve = null

let getInstance = () => {
  return new DialogInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (dialogResolve) {
    dialogResolve(false)
    dialogResolve = null
  }
  dialogPromise = null
}

let newLibraryMaterial = (msg) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  dialogPromise = new Promise((resolve, reject) => {
    dialogResolve = resolve
  })
  instance.open(msg, dialogResolve)

  return dialogPromise
}

export default newLibraryMaterial
